import { Box, Text, TextButton } from '@wix/design-system';
import { Trans } from '@wix/fe-essentials/react';
import { RuleDescription } from '@wix/rules-panel-ui';
import React from 'react';
export const RuleDescriptionComponent = _ref => {
  let {
    i18nKey,
    textButtonAriaLabel,
    i18nKeyValues,
    openArticle,
    title,
    ruleId
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical"
  }, title && /*#__PURE__*/React.createElement(Box, {
    marginBottom: "SP2"
  }, /*#__PURE__*/React.createElement(Text, {
    dataHook: `${ruleId}-rule-description-title`,
    size: "tiny",
    weight: "bold"
  }, title)), /*#__PURE__*/React.createElement(RuleDescription, {
    dataHook: `${ruleId}-rule-description`
  }, /*#__PURE__*/React.createElement(Trans, {
    components: {
      text: /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        secondary: true
      }),
      textButton: /*#__PURE__*/React.createElement(TextButton, {
        ariaLabel: textButtonAriaLabel,
        dataHook: `${ruleId}-rule-description-learn-more`,
        size: "tiny",
        skin: "dark",
        underline: "always",
        weight: "thin",
        onClick: openArticle
      })
    },
    i18nKey: i18nKey,
    values: i18nKeyValues
  })));
};
//# sourceMappingURL=rule-description-component.js.map